/**
 * Normaliza um valor de data para o formato ISO "yyyy-mm-dd" no fuso
 * local do usuario.
 *
 * Casos cobertos:
 *  - ''       / null / undefined           -> '' (vazio)
 *  - '2026-05-29'                          -> '2026-05-29' (passa direto)
 *  - '2026-05-28T21:00:00.000Z' (UTC)      -> '2026-05-29' (Brasilia UTC-3)
 *  - '2026-05-29T03:00:00-03:00' (offset)  -> '2026-05-29'
 *  - Date object                            -> 'yyyy-mm-dd' local
 *
 * Por que isto existe:
 *   Po-datepicker as vezes serializa o ngModel como ISO datetime com
 *   timezone UTC (ex.: meia-noite local = 21h do dia anterior em UTC).
 *   O backend Protheus (PnfShpParseDate) extrai os 8 primeiros digitos
 *   da string sem considerar offset, resultando em pasta SharePoint com
 *   dia D-1 do vencimento. Garantir aqui que o front sempre envia a
 *   data no fuso local elimina o bug pela raiz.
 */
export function toIsoDateLocal(v: string | Date | null | undefined): string {
  if (!v) return '';
  if (typeof v === 'string') {
    // Ja no formato yyyy-mm-dd? retorna como esta
    if (/^\d{4}-\d{2}-\d{2}$/.test(v)) {
      return v;
    }
    const d = new Date(v);
    if (isNaN(d.getTime())) return '';
    return formatLocal(d);
  }
  if (v instanceof Date) {
    if (isNaN(v.getTime())) return '';
    return formatLocal(v);
  }
  return '';
}

function formatLocal(d: Date): string {
  const y = d.getFullYear();
  const m = (d.getMonth() + 1).toString().padStart(2, '0');
  const day = d.getDate().toString().padStart(2, '0');
  return `${y}-${m}-${day}`;
}
